import { generateId } from '../utils';
import Course from '../models/Course';
import Subject from '../models/Subject';
import Topic from '../models/Topic';
import Question from '../models/Question';
import Answer from '../models/Answer';

let input = require('./questions-input.json')[0];
let examRules = require('./exam-rules.json');

export default [
    new Course(
        1,
        'ВОДАЧ НА КОРАБ ДО 40 БТ ПО МОРЕ',
        getData(input['SkipperUpTo40GTAtSea'], 'SkipperUpTo40GTAtSea_media'),
        examRules['SkipperUpTo40GTAtSea']
    ),
    new Course(
        2,
        'ВОДАЧ НА МАЛЪК КОРАБ (река)',
        getData(input['SmallShipSkipperAtRiver'], 'SmallShipSkipperAtRiver_media'),
        examRules['SmallShipSkipperAtRiver']
    ),
    new Course(
        3,
        'ВОДАЧ НА МАЛЪК КОРАБ ЗА СПОРТ И РАЗВЛЕЧЕНИЕ ПО ВВПЕ',
        getData(input['SmallShipSkipperForSportsAndEntertainmentOnTheInlandWaterWaysOfEurope'], 'SmallShipSkipperForSportsAndEntertainmentOnTheInlandWaterWaysOfEurope_media'),
        examRules['SmallShipSkipperForSportsAndEntertainmentOnTheInlandWaterWaysOfEurope']
    ),
    new Course(
        4,
        'От ВОДАЧ НА КОРАБ ДО 40 БТ ПО МОРЕ за ВОДАЧ НА МАЛЪК КОРАБ (река)',
        getData(input['SkipperUpTo40GTAtSeaToSmallShipSkipperAtRiver'], 'SkipperUpTo40GTAtSeaToSmallShipSkipperAtRiver_media'),
        examRules['SkipperUpTo40GTAtSeaToSmallShipSkipperAtRiver']
    ),
    new Course(
        5,
        'От ВОДАЧ НА МАЛЪК КОРАБ (река) за ВОДАЧ НА КОРАБ ДО 40 БТ ПО МОРЕ',
        getData(input['SmallShipSkipperAtRiverToSkipperUpTo40GTAtSea'], 'SmallShipSkipperAtRiverToSkipperUpTo40GTAtSea_media'),
        examRules['SmallShipSkipperAtRiverToSkipperUpTo40GTAtSea']
    ),
];

function getData(input, imageDirectory) {
    let subjects = [];

    for (let question of input) {
        let subjectTitle = question.Subject ? question.Subject.trim() : 'Неопределен';
        let topicTitle = question.Topic ? question.Topic.trim() : 'Неопределен';
        let subjectId = generateId(subjectTitle);
        let topicId = generateId(topicTitle);

        let subject = subjects.find(({ id }) => id === subjectId);

        if (!subject) {
            subject = {
                id: subjectId,
                title: subjectTitle,
                topics: [],
            };

            subjects.push(subject);
        }

        let topic = subject.topics.find(({ id }) => id === topicId);

        if (!topic) {
            topic = {
                id: topicId,
                title: topicTitle,
                questions: [],
            };

            subject.topics.push(topic);
        }

        topic.questions.push(new Question(
            question.ID,
            question.Question.trim(),
            question.QuestionImage && question.QuestionImage.trim() ?
                '/img/' + imageDirectory + '/' + question.QuestionImage.trim() : null,
            [
                new Answer(
                    1,
                    question.Answer1 ? question.Answer1.trim() : question.Answer1,
                    !!question.IsAnswer1Correct
                ),
                new Answer(
                    2,
                    question.Answer2 ? question.Answer2.trim() : question.Answer2,
                    !!question.IsAnswer2Correct
                ),
                new Answer(
                    3,
                    question.Answer3 ? question.Answer3.trim() : question.Answer3,
                    !!question.IsAnswer3Correct
                ),
                new Answer(
                    4,
                    question.Answer4 ? question.Answer4.trim() : question.Answer4,
                    !!question.IsAnswer4Correct
                )
            ],
            topicId,
            subjectId
        ));
    }

    return subjects.map(
        subjectData => new Subject(
            subjectData.id,
            subjectData.title,
            subjectData.topics.map(topicData => new Topic(
                topicData.id,
                topicData.title,
                topicData.questions
            ))
        )
    )
}